import {indexDiscussion} from './discussionModel.js';

// Project the server-confirmed scope after a committed deletion. Ownership is
// structural: a source link to an existing target does not own that target.
export function projectThreadDeletion(comments,{rootId,termId,affected}={}) {
 const model=indexDiscussion(comments),source=model.byId.get(rootId);
 const scopeTerm=termId||source?.termId;
 if(!rootId||!scopeTerm)return comments;
 const polls=new Set((affected?.polls||[]).map(item=>item.id));
 const options=new Map((affected?.options||[]).map(item=>[item.id,item.pollId]));
 const candidates=new Set((affected?.candidates||[]).map(item=>item.id));
 const removed=new Set([rootId]),roots=new Map();
 for(const comment of comments){
  if(comment.termId!==scopeTerm)continue;
  const root=model.rootOf(comment);
  if(root?.termId===scopeTerm)roots.set(root.id,root);
 }
 for(const root of roots.values()){
  const context=root.pollContext;
  if(candidates.has(root.nameProposal?.id)||polls.has(context?.pollId)||
    (context?.optionId&&options.has(context.optionId)&&options.get(context.optionId)===context.pollId))removed.add(root.id);
 }
 // Source-created discussions can create further owned items. Walk that chain
 // without following background/source associations into shared discussions.
 let changed=true;
 while(changed){
  changed=false;
  for(const root of roots.values()){
   if(!removed.has(root.id)&&removed.has(root.threadOwnerRootId)){removed.add(root.id);changed=true;}
  }
 }
 return comments.filter(comment=>comment.termId!==scopeTerm||!removed.has(model.rootOf(comment)?.id));
}
